// import { create } from "zustand";

// export const useStoreBilling = create((set, get) => ({
//   plans: [],
//   metadata: {},

//   setPlans: (data) =>
//     set({
//       plans: data?.plans,
//       metadata: data?.metadata,
//     }),
// }));

import { create } from "zustand";

export const useStoreBilling = create((set, get) => ({
  plans: [],
  metadata: {},
  one_time_credits: {},
  subscriptions: [],
  trials: [],
  payment_methods: [],
  one_time_purchases: [],
  summary: {},
  creditOverview: {},

  setPlans: (data) => {
    if (!data?.subscription_plans || data.subscription_plans.length < 2) return; // guard clause

    // Clone the plans so we don't mutate the original
    const plans = [...data.subscription_plans];

    // Swap first and second positions
    const reorderedPlans = [plans[1], plans[0]];

    // Rename "Enterprise" → "Pro"
    // const updatedPlans = reorderedPlans.map((plan) =>
    //   plan.name === "Enterprise" ? { ...plan, name: "Pro" } : plan
    // );

    set({
      plans: reorderedPlans,
      metadata: data.metadata,
      one_time_credits: data?.one_time_credits,
    });
  },
  setSubscriptions: (data) => {
    set({
      subscriptions: data?.subscriptions,
      trials: data?.trials,
      payment_methods: data?.payment_methods,
      one_time_purchases: data?.one_time_purchases,
      summary: data?.summary,
    });
  },
  setCreditOverview: (data) => {
    set({
      creditOverview: data?.data,
    });
  },
}));
